export const storage = {
  get: (key: string): string | null => sessionStorage.getItem(key) || localStorage.getItem(key),
  set: (key: string, value: string, permanent = false): void =>
    permanent ? localStorage.setItem(key, value) : sessionStorage.setItem(key, value),
  clear: (): void => {
    localStorage.clear();
    sessionStorage.clear();
  }
};
